import { Moment } from "moment";

export interface ICarrierCertificate {
    id: number;
    documentType: number;
    documentTypeName: string;
    certificationId: number;
    documentName: string;
    status: number;
    expirationDate?: Moment;
}
export class CarrierCertificate implements ICarrierCertificate {
    id: number;
    documentType: number;
    documentTypeName: string;
    certificationId: number;
    documentName: string;
    status: number;
    expirationDate?: Moment;
}

